"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfDocumentAuditNameComparisonDto = instanceOfDocumentAuditNameComparisonDto;
exports.DocumentAuditNameComparisonDtoFromJSON = DocumentAuditNameComparisonDtoFromJSON;
exports.DocumentAuditNameComparisonDtoFromJSONTyped = DocumentAuditNameComparisonDtoFromJSONTyped;
exports.DocumentAuditNameComparisonDtoToJSON = DocumentAuditNameComparisonDtoToJSON;
exports.DocumentAuditNameComparisonDtoToJSONTyped = DocumentAuditNameComparisonDtoToJSONTyped;
const DocumentAuditNamePartsDto_1 = require("./DocumentAuditNamePartsDto");
/**
 * Check if a given object implements the DocumentAuditNameComparisonDto interface.
 */
function instanceOfDocumentAuditNameComparisonDto(value) {
    if (!('matched' in value) || value['matched'] === undefined)
        return false;
    if (!('claimed' in value) || value['claimed'] === undefined)
        return false;
    if (!('extracted' in value) || value['extracted'] === undefined)
        return false;
    return true;
}
function DocumentAuditNameComparisonDtoFromJSON(json) {
    return DocumentAuditNameComparisonDtoFromJSONTyped(json, false);
}
function DocumentAuditNameComparisonDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'matched': json['matched'],
        'claimed': (0, DocumentAuditNamePartsDto_1.DocumentAuditNamePartsDtoFromJSON)(json['claimed']),
        'extracted': (0, DocumentAuditNamePartsDto_1.DocumentAuditNamePartsDtoFromJSON)(json['extracted']),
    };
}
function DocumentAuditNameComparisonDtoToJSON(json) {
    return DocumentAuditNameComparisonDtoToJSONTyped(json, false);
}
function DocumentAuditNameComparisonDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'matched': value['matched'],
        'claimed': (0, DocumentAuditNamePartsDto_1.DocumentAuditNamePartsDtoToJSON)(value['claimed']),
        'extracted': (0, DocumentAuditNamePartsDto_1.DocumentAuditNamePartsDtoToJSON)(value['extracted']),
    };
}
//# sourceMappingURL=DocumentAuditNameComparisonDto.js.map